unit Web.StringUtils;

interface

/// <summary>
///  Escape single quotes in Firebird query strings
/// </summary>
function EscapeSingleQuotesFirebird(const aSource: string): string;

/// <summary>
///  Determines whether a string contains alpha characters
/// </summary>
function ContainsAlpha(Value: string): Boolean;

implementation


function EscapeSingleQuotesFirebird(const aSource: string): string;
var
  iIdx: Integer;
  sOutput: string;

begin
  sOutput := '';
  iIdx := 1;
  while iIdx <= Length(aSource) do
  begin
    if aSource[iIdx] = '''' then
    begin
      // Check if it's already escaped (i.e., two consecutive single quotes)
      if (iIdx < Length(aSource)) and (aSource[iIdx + 1] = '''') then
      begin
        sOutput := sOutput + ''''''; // Add the already escaped quotes
        Inc(iIdx, 2); // Skip both

      end
      else
      begin
        sOutput := sOutput + ''''''; // Escape it (double it)
        Inc(iIdx); // Skip one

      end;

    end
    else
    begin
      sOutput := sOutput + aSource[iIdx];
      Inc(iIdx);

    end;

  end;
  Result := sOutput;

end;

function ContainsAlpha(Value: string): Boolean;
var
  iIdx: Integer;

begin
  Result := False;
  for iIdx := 1 to Length(Value) do
    Result := Result or (Value[iIdx] in ['A'..'Z', 'a'..'z']);

end;


end.
